import BabyUIThemeProvider from 'baby-ui/foundation/BabyUIThemeProvider'
import { babylistHealth } from 'lib/urls'
import Button from 'baby-ui/foundation/Button'
import { Box } from '@material-ui/core'
import { GetPumpThroughInsuranceModalTheme } from '../themes/GetPumpThroughInsuranceModalTheme'

const theme = new GetPumpThroughInsuranceModalTheme()
const MARGIN = 2

export interface GetPumpThroughInsuranceModalProps {
  onProceedWithAction: () => void
  babylistHealthButtonLabel: string
  alternativeActionLabel: string
  onActionClick: (ctaText: string) => void
}

const GetPumpThroughInsuranceModalActions = ({
  onProceedWithAction,
  babylistHealthButtonLabel,
  alternativeActionLabel,
  onActionClick,
}: GetPumpThroughInsuranceModalProps) => (
  <BabyUIThemeProvider theme={theme}>
    <Box my={MARGIN}>
      <Button
        fullWidth
        color="secondary"
        href={babylistHealth}
        size="large"
        variant="contained"
        onClick={() => onActionClick(babylistHealthButtonLabel)}
        style={{ color: 'white' }}
        // @ts-ignore
        target="_blank"
      >
        {babylistHealthButtonLabel}
      </Button>
    </Box>
    <Box mb={MARGIN}>
      <Button
        fullWidth
        color="primary"
        size="large"
        variant="outlined"
        onClick={() => {
          onActionClick(alternativeActionLabel)
          onProceedWithAction()
        }}
      >
        {alternativeActionLabel}
      </Button>
    </Box>
  </BabyUIThemeProvider>
)

export default GetPumpThroughInsuranceModalActions
